// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4611453f","223":"527a7c06","239":"07939775","455":"ea30d29d"}[chunkId] + ".chunk.js";
};